import { useCallback } from 'react';

import { Alert } from '@treezor/design-system';

import { useRoutepaths } from '@/router/hooks/useRoutePaths';

import { useAlert } from './useAlert';

export function RootAlert() {
  const { navigate, t, handleAlertClose, alertClasses, handleAlertValidate } = useAlert('userRootWarning');

  const PathRoute = useRoutepaths();

  const handleAlertAction = useCallback(() => {
    handleAlertClose();
    handleAlertValidate();
    navigate(`/app/${PathRoute.app.dashboardUsers}`);
  }, [navigate, handleAlertClose, handleAlertValidate, PathRoute.app.dashboardUsers]);

  return (
    <Alert
      title={t('pages.cores.warnings.rootAccount.title')}
      description={t('pages.cores.warnings.rootAccount.description')}
      isClosable
      variant="secondary"
      type="warning"
      action={{
        title: t('pages.cores.warnings.rootAccount.createPersonalAccount'),
        onClick: handleAlertAction,
      }}
      onClose={handleAlertClose}
      className={alertClasses}
    />
  );
}

export default RootAlert;
